/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["header[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.8);padding:0 16px;width:calc(100vw - 16px * 2);position:fixed;top:0;z-index:999}header[_ngcontent-%COMP%]   main[_ngcontent-%COMP%]{margin:0 auto;width:calc(100vw - 16px * 2);max-width:calc(990px - 16px * 2)}.height[_ngcontent-%COMP%]{transition:height .2s;height:85px}.height.scrolled[_ngcontent-%COMP%]{height:55px}"];
export { styles as styles };
